import { Link } from 'react-router-dom';

export default function VideoGalleryFooter() {
  return (
    <footer className="bg-stone-900 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/bff3983fcac7598cf15bb5173700e0d7/b58838733802ef1d20431284565f42b3.jpeg"
                alt="House of FMR"
                className="h-16 w-16 object-contain"
              />
              <div>
                <p className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-100 to-amber-300 font-serif text-lg font-semibold">House of FMR</p>
                <p className="text-amber-400 text-xs tracking-wider uppercase">
                  Events & Styling
                </p>
              </div>
            </Link>
            <p className="text-white/40 text-sm leading-relaxed max-w-md mb-6">
              Sydney's premier luxury mixology academy. Learn the art of cocktail making from expert instructors in an intimate, glamorous setting.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:bg-amber-500/20 hover:text-amber-400 transition-all cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:bg-amber-500/20 hover:text-amber-400 transition-all cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:bg-amber-500/20 hover:text-amber-400 transition-all cursor-pointer">
                <i className="ri-tiktok-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/50 hover:text-amber-400 transition-colors text-sm cursor-pointer">Home</Link>
              </li>
              <li>
                <Link to="/#classes" className="text-white/50 hover:text-amber-400 transition-colors text-sm cursor-pointer">Classes</Link>
              </li>
              <li>
                <Link to="/video-gallery" className="text-amber-400 text-sm cursor-pointer">Video Gallery</Link>
              </li>
              <li>
                <Link to="/gallery" className="text-white/50 hover:text-amber-400 transition-colors text-sm cursor-pointer">Photo Gallery</Link>
              </li>
              <li>
                <Link to="/wishlist" className="text-white/50 hover:text-amber-400 transition-colors text-sm cursor-pointer">Wishlist</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/50 text-sm">
                <i className="ri-map-pin-line text-amber-400"></i>
                Sydney, Australia
              </li>
              <li className="flex items-center gap-3 text-white/50 text-sm">
                <i className="ri-mail-line text-amber-400"></i>
                hello@houseoffmr.com
              </li>
              <li className="flex items-center gap-3 text-white/50 text-sm">
                <i className="ri-phone-line text-amber-400"></i>
                +61 400 000 000
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-sm">
            © {new Date().getFullYear()} House of FMR. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/30 text-sm hover:text-amber-400 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
